import { render, staticRenderFns } from "./manage-coverage.component.vue?vue&type=template&id=ba0f44be&"
import script from "./manage-coverage.component.vue?vue&type=script&lang=ts&"
export * from "./manage-coverage.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports